export const permissions = {
    ADMIN: 4294967295, // 2^32 - 1
    USER_ADD: Math.pow(2, 0),
    USER_DELETE: Math.pow(2, 1),
    GROUP_ADD: Math.pow(2, 2),
    GROUP_EDIT: Math.pow(2, 3),
    GROUP_DELETE: Math.pow(2, 4),
    GROUP_CHANGE: Math.pow(2, 5),
    REPOSITORY_FULL: Math.pow(2, 6),
    REPOSITORY_PARANOID: Math.pow(2, 7),
    DATES_ADDEDIT: Math.pow(2, 8),
    DATES_DELETE: Math.pow(2, 9),
}

export const rights = {
    ACCESS: Math.pow(2, 0),
    ADD: Math.pow(2, 1),
    DELETE: Math.pow(2, 2)
}

export const permissionsTable = [
    {
        name: "Administrator",
        permition: permissions.ADMIN,
        children: [
            {
                name: "Zarządzanie użytkownikami",
                permition:
                    permissions.USER_ADD |
                    permissions.USER_DELETE,
                children: [
                    {
                        name: "Dodawanie nowych użytkowników do projektu",
                        permition: permissions.USER_ADD
                    },
                    {
                        name: "Usuwanie istniejących użytkowników z projektu",
                        permition: permissions.USER_DELETE
                    }
                ]
            },
            {
                name: "Zarządzanie grupami",
                permition:
                    permissions.GROUP_ADD |
                    permissions.GROUP_EDIT |
                    permissions.GROUP_DELETE |
                    permissions.GROUP_CHANGE,
                children: [
                    {
                        name: "Dodawanie nowych grup",
                        permition: permissions.GROUP_ADD
                    },
                    {
                        name: "Edytowanie grup i ich uprawnień",
                        permition: permissions.GROUP_EDIT
                    },
                    {
                        name: "Usuwanie istniejących grup",
                        permition: permissions.GROUP_DELETE
                    },
                    {
                        name: "Zmiana grup użytkowników",
                        permition: permissions.GROUP_CHANGE
                    }
                ]
            },
            {
                name: "Zarządzanie repozytorium",
                permition:
                    permissions.REPOSITORY_FULL |
                    permissions.REPOSITORY_PARANOID,
                children: [
                    {
                        name: "Pełen dostęp do repozytorium",
                        permition: permissions.REPOSITORY_FULL
                    },
                    {
                        name: "Tryb administratora repozytorium",
                        permition: permissions.REPOSITORY_PARANOID
                    }
                ]
            },
            {
                name: "Zarządzanie harmonogramem",
                permition:
                    permissions.DATES_ADDEDIT |
                    permissions.DATES_DELETE,
                children: [
                    {
                        name: "Dodawanie nowych i edycja istniejących wydarzeń",
                        permition: permissions.DATES_ADDEDIT
                    },
                    {
                        name: "Usuwanie istniejących wydarzeń",
                        permition: permissions.DATES_DELETE
                    }
                ]
            }
        ]
    }
]